import Vue from 'vue';
import store from './store';

import CommunitiesMap from '@/CommunitiesMap';
import OverviewMap from '@/OverviewMap';
import QuickMoveInsMap from '@/QuickMoveInsMap';

Vue.config.productionTip = false;

// Import any Plugins we want globally available in the application
import axios from './plugins/axios';

// Run Plugin functions
axios({ store, Vue });

const CommunitiesMapDiv = document.getElementById('communities-map');
// console.log('main.js CommunitiesMapDiv', CommunitiesMapDiv);
if (CommunitiesMapDiv) {
  new Vue({
    store,
    render: (h) => h(CommunitiesMap, { props: { city: CommunitiesMapDiv.dataset.city } }),
  }).$mount('#communities-map');
}

const OverviewMapDiv = document.getElementById('overview-map');
// console.log('main.js OverviewMapDiv', OverviewMapDiv);
if (OverviewMapDiv) {
  new Vue({
    store,
    render: (h) => h(OverviewMap, { props: { address: OverviewMapDiv.getAttribute('data-address') } }),
  }).$mount('#overview-map');
}

const QuickMoveInsMapDiv = document.getElementById('quick-move-ins-map');
// console.log('main.js QuickMoveInsMapDiv', QuickMoveInsMapDiv);
if (QuickMoveInsMapDiv) {
  new Vue({
    store,
    render: (h) => h(QuickMoveInsMap, { props: { city: QuickMoveInsMapDiv.dataset.city } }),
  }).$mount('#quick-move-ins-map');
}
